import React, { useRef, useState, useEffect } from 'react'
import './index.scss'
// import HeaderWeb from '@/components/headerweb'
import inviteImg from '@/assets/images/invite.jpg'
// import hhinviteImg from '@/assets/images/hhinvite.jpg'
import phoneImg from '@/assets/images/shouji.png'
import renImg from '@/assets/images/ren.png'
import weizhi from '@/assets/images/weizhi.png'
import { connect } from 'react-redux'
import { sendPhoneCode } from '@/utils/sendPhoneCode'
import { isPhone } from '@/utils/utils'
import { showToast } from '@/components/toast'
import { Picker, List } from 'antd-mobile';
import { logincityAction } from '@/store/actions/logincityAction.js'
import useDeepCompareEffect from 'use-deep-compare-effect'
const mapStateToProps = (state) => ({
  tenant: state.getIn(['tenantReducer', 'tenant']),
  cityData: state.getIn(['logincityReducer', 'cityData'])
})
const mapDispatchToProps = (dispatch) => ({
  handleGetCity() {
    return dispatch(logincityAction())
  }
})
const GetCash = (props) => {
  let { handleGetCity, cityData } = props
  // 城市选择
  let [city, setCity] = useState();
  // 一个城市的时候城市显示
  let [cityOne,setCityOne] = useState('');
  // choosetxt
  let [choosetxt, setChoosetxt] = useState('请选择');
  // 城市列表
  let [cityDataState, setCityDataState] = useState([]);
  //input dom
  const inputRef = useRef(null)
  // 司机名字
  const driverNameRef = useRef(null)
  let { history } = props
  //出行平台的唯一标识
  let cxname = props.tenant
  const handleGetCash = () => {
    if (!city) {
      showToast('请选择服务城市');
      return
    }
    if (!driverNameRef.current.value) {
      showToast('请填写您的姓名');
      return
    }
    if (!inputRef.current.value) {
      showToast('请填写您的手机号');
      return
    }
    //发送手机验证码
    if (isPhone(inputRef.current.value) && driverNameRef.current.value) {
      sendPhoneCode(inputRef.current.value)
        .then((data) => {
          let { errorCode, errorMsg } = data.data
          if (errorMsg === '请不要频繁获取验证码') {
            inputRef.current.value = ''
            inputRef.current.placeholder = '请不要频繁操作,1分钟之后重新获取'
            
          }else if (errorMsg === 'SUCCESS' && errorCode === 0) {
            console.log('出行平台唯一标识',cxname)
            history.push({
              pathname: `/phoneverify/${cxname}/${inputRef.current.value}/${driverNameRef.current.value}/${city}`
            })
          }
        })
    } else {
      inputRef.current.value = ''
      inputRef.current.placeholder = '请正确填写您的手机号'
      showToast('请正确填写您的手机号')
    }
  }
  // 获取城市信息
  useEffect(() => {
    handleGetCity()
    return () => { }
  }, [handleGetCity])
  // 赋值
  useDeepCompareEffect(() => {
    let newArr = [];
    for (let i = 0, k = cityData.length; i < k; i++) {
      let obj = {}
      if (cityData[i].cityId && cityData[i].cityName) {
        obj.value = cityData[i].cityId
        obj.label = cityData[i].cityName
        newArr.push(obj)
      }
    }
    setCityDataState(newArr);
  }, [cityData])
  // 监测cityDataState
  useDeepCompareEffect(() => {
    // 如果只有一个城市数据,直接传递城市名称
    if (cityDataState.length === 1) {
      setCityOne(cityDataState[0].label)
      setCity(cityDataState[0].value)
    }
  }, [cityDataState])
  // 选中方法
  function handlecityChoose(v) {
    setCity(v[0])
    for (let i = 0, k = cityDataState.length; i < k; i++) {
      if (cityDataState[i].value === v[0]) {
        setChoosetxt(cityDataState[i].label)
        return;
      }
    }

  }
  return (
    <div className="get-cash__box">
      {/* <HeaderWeb tit="领取现金" /> */}
      <div className="get-cash__info">
        <div className="get-cash__banner">
          <img src={
            //).tenantTag === 'tonggang' ? inviteImg : 
            // ).tenantTag === 'henghao' ? hhinviteImg :(
            //  ).tenantTag === 'nineh' ? hhinviteImg : (
            //    ).tenantTag === 'qianxing' ? hhinviteImg :inviteImg
            //   ))  )
            inviteImg
          } alt="" />
          <h1>{cxname}</h1>
          <h2>网约车司机大招募</h2>
          {/* <h3>下单即享现金好礼</h3> */}
          {/* <p style={React.colorConfig ? React.colorConfig.bannerTxt : {}}>注册后完成首单后，可获得20元奖励</p> */}
        </div>
        <div className="phone-input__box">
          <div style={{ width: '100%' }} className="city-choose">
            <em><img src={weizhi} alt="" /></em>
            {
              cityDataState.length <= 1 ?
                <div className="city-choose__box">
                  <em>服务城市</em>
                  <span>{cityOne}</span>
                </div>
                :
                <Picker cols={1} extra={choosetxt} data={cityDataState} className="forss" onOk={handlecityChoose}>
                  <List.Item arrow="horizontal">服务城市 </List.Item>
                </Picker>
            }

          </div>
          <div className="drivername">
            <em><img src={renImg} alt="" /></em>
            <input type="text" placeholder="请输入您的名字" ref={driverNameRef} />
          </div>
          <div className="phone">
            <em><img src={phoneImg} alt="" /></em>
            <input type="number" placeholder="请输入您的手机号" ref={inputRef} />
          </div>

        </div>
      </div>
      <footer>
        <button onClick={handleGetCash} >立即注册</button>
      </footer>
    </div>
  )
}
export default connect(mapStateToProps, mapDispatchToProps)(GetCash)
